import createAxiosInstance from './axiosConfig';
import { RelatoriosDTO } from "../shared/dto/relatoriosDTO";
import { FiltroUsuarioDTO } from "../shared/dto/filtroUsuarioDTO";
import { RelatoriosPriceDTO } from '../shared/dto/relatoriosPriceDTO';

const { REACT_APP_ESTEIRA_BACK } = process.env;

const axiosInstance = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/rest/relatorioController');

export default class RelatorioService {
  axios: any;

  constructor() {
    this.axios = axiosInstance;
  }

  async gerarRelatorioContratosCedidos(dto: RelatoriosDTO) {
    return await this.axios.post(`/gerarRelatorioContratosCedidos`, dto, {
      responseType: 'blob',
    });
  };

  async gerarRelatorioDeVencimento(dto: RelatoriosDTO) {
    return await this.axios.post(`/gerarRelatorioDeVencimento`, dto, {
      responseType: 'blob',
    });
  };

  async gerarRelatorioDeMovimentacaoFinanceira(dto: RelatoriosDTO) {
    return await this.axios.post(`/gerarRelatorioDeMovimentacaoFinanceira`, dto, {
      responseType: 'blob',
    });
  };

  async gerarRelatorioDeMovimentacaoBaixaFinanceira(dto: RelatoriosDTO) {
    return await this.axios.post(`/gerarRelatorioDeMovimentacaoBaixaFinanceira`, dto, {
      responseType: 'blob',
    });
  };

  async gerarRelatorioOperacaoRealizada(dto: RelatoriosDTO) {
    return await this.axios.post(`/gerarRelatorioOperacaoRealizada`, dto, {
      responseType: 'blob',
    });
  };

  async gerarRelatorioParcelasCedidas(dto: RelatoriosDTO) {
    return await this.axios.post(`/gerarRelatorioParcelasCedidas`, dto, {
      responseType: 'blob',
    });
  };

  async gerarRelatorioCliente(dto: RelatoriosDTO) {
    return await this.axios.post(`/gerarRelatorioCliente`, dto, {
      responseType: 'blob',
    });
  };
  
  async gerarRelatorioOrigensCadastradas(dto: RelatoriosDTO) {
    return await this.axios.post(`/gerarRelatorioOrigensCadastradas`, dto, {
      responseType: 'blob',
    });
  };

  async gerarRelatorioProducaoAnalitico(dto: RelatoriosDTO) {
    return await this.axios.post(`/gerarRelatorioProducaoAnalitico`, dto, {
      responseType: 'blob',
    });
  };

  async gerarRelatorioProducaoSintetico(dto: RelatoriosDTO) {
    return await this.axios.post(`/gerarRelatorioProducaoSintetico`, dto, {
      responseType: 'blob',
    });
  };

  async gerarRelatorioExtratoMensal(dto: RelatoriosDTO) {
    return await this.axios.post(`/gerarRelatorioExtratoMensal`, dto, {
      responseType: 'blob',
    });
  };

  async gerarRelatorioUsuarios(dto: FiltroUsuarioDTO) {
    return await this.axios.post(`/gerarRelatorioUsuarios`, dto, {
      responseType: 'blob',
    });
  };

  /*
  async gerarRelatorioConfirmacaoComunicados(dto: FiltroComunicadoDTO) {
    return await this.axios.post(`/gerarRelatorioConfirmacaoComunicados`, dto, {
      responseType: 'blob',
    });
  };
  */

  async gerarRelatorioPrice(dto: RelatoriosPriceDTO) {
    return await this.axios.post(`/gerarRelatorioPrice`, dto, {
      responseType: 'blob',
    });
  };

  async gerarRelatorioConfirmacaoComunicados(uuid: string): Promise<any> {
    try {
      const response = await this.axios.post(
        '/gerarRelatorioConfirmacaoComunicados',
        null,
        {
          params: { uuid },
          responseType: 'blob',
          headers: {
            'Accept': 'text/csv, application/csv'
          }
        }
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async gerarRelatorioExpectativaCsv(dto: RelatoriosDTO) {
    return await this.axios.post(`/gerarRelatorioExpectativa`, dto, {
      responseType: 'blob', // Crucial para o download do arquivo
      headers: {
        'Content-Type': 'application/json' // Previne o erro 415 caso o axios global tente enviar como Excel
      }
    });
  };

  //MOCK
  async gerarRelatorioFaturasComissao(dto: RelatoriosDTO) {
    return await this.axios.post(`/gerarRelatorioFaturasComissao`, dto, {
      responseType: 'blob',
    });
  };  

}
